<template>
    <img class="topImgSty" :src="pictureLang[$i18n.locale]">
</template>
<script>
export default {
    data() {
        return {
            pictureLang: {
                en: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169209977351144904262087967406.png",
                ja: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920999806799074647306692181.png",
                "zh-cn": "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16921008925018188541220176175.jpg",
            }
        }
    },
}
</script>
<style></style>
 


// WEBPACK FOOTER //
// src/components/topPicResponsibility.vue